export const api: string = "/api/v2";
export const SESSION_ID_REQ_PARAM: string = "SessionId";

export const connectApi = {
  login: `${api}/connect/authorize/login`,
  register: `${api}/connect/register/users`,
  registerUnityUser: `${api}/connect/register/invites/{inviteToken}/users`,
  validate: `${api}/connect/validate`,
  sharedDocuments: `${api}/connect/sharedDocumentsPackages/`,
  getCirfsForCurrentUser: `${api}/connect/cirfs`,
  getSharedDocumentsPackagesForCurrentUser: `${api}/connect/sharedDocumentsPackages`,
  getReferralsForCurrentUser: `${api}/connect/referrals`,
  getParticipatingMatters: `${api}/connect/user/matters`,
  downloadDocument: `${api}/connect/sharedDocumentsPackages/{packageGuid}/documents/{documentId}/download`,
  downloadAttachedDocument: `${api}/connect/matters/{matterId}/documents/{documentId}/download`,
  getCirf: `${api}/connect/cirfs/`,
  updateCirf: `${api}/connect/cirfs/`,
  updateReferrals: `${api}/connect/referrals`,
  getReferrals: `${api}/connect/referrals/`,
  termsAndConditions: `${api}/connect/reference/termsAndConditions`,
  setTermsAndConditions: `${api}/connect/user/termsAndConditions/accept`,
  forgotPassword: `${api}/connect/register/resetPasswordLink`,
  resetPassword: `${api}/connect/register/resetPassword`,
  getUserByToken: `${api}/connect/register`,
  uploadFile: `${api}/connect/cirfs/{cirfGuid}/documents/upload`,
  uploadClientFile: `${api}/connect/cirfs/{cirfGuid}/clients/{clientId}/documents/upload`,
  parseAndUploadDriverLicense: `${api}/connect/cirfs/{cirfGuid}/clients/{clientId}/documents/driverLicense/parseAndUpload`,
  uploadMortgageFile: `${api}/connect/cirfs/{cirfGuid}/mortgages/{mortgageId}/documents/upload`,
  getCirfDocuments: `${api}/connect/cirfs/{cirfGuid}/documents`,
  deleteCirfDocument: `${api}/connect/cirfs/{cirfGuid}/documents/{documentId}`,
  searchPlaces: `${api}/reference/places/?source={addressSource}&countryCode={countryCode}&input={input}`,
  searchPlacesById: `${api}/reference/places/findById/{lastId}`,
  searchPlacesByIdAndSource: `${api}/reference/places/{lastId}?source={source}`,
  ids: `${api}/util/guids`,
  getAccounts: `${api}/connect/customerAccounts`,
  contactsList: `${api}/connect/contactsList`,
  searchSolicitors: `${api}/connect/searchSolicitors`,
  lendersContactList: `${api}/connect/lendersContactList`,
  contacts: `${api}/connect/contacts`,
  loggedInStaffProfiles: `${api}/connect/users/currentUser/myProfile`,
  customPickLists: `${api}/connect/cirfs/{cirfGuid}/customPickLists`,
  getSharedDocPackageFirmLogo: `${api}/connect/sharedDocumentsPackages/{packageGuid}/files/{fileId}/download?${SESSION_ID_REQ_PARAM}={sessionId}`,
  getCirfFirmLogo: `${api}/connect/cirfs/{cirfGuid}/files/{fileId}/download?${SESSION_ID_REQ_PARAM}={sessionId}`,
  getReferralFirmLogo: `${api}/connect/referrals/{referralId}/files/{fileId}/download?${SESSION_ID_REQ_PARAM}={sessionId}`,
  getParticipatingMatterFirmLogo: `${api}/connect/matters/{matterId}/files/{fileId}/download?${SESSION_ID_REQ_PARAM}={sessionId}`,
  credentials: `${api}/users/currentUser/credentials`,
  getCirfMatterInfo: `${api}/connect/cirfs/{cirfGuid}/matterInfo`,
  getMatterInfoByMatterId: `${api}/connect/user/matters/{matterId}/matterInfo`,
  getReferralMatterInfo: `${api}/connect/referrals/{referralId}/matterInfo`,
  uploadReferralFile: `${api}/connect/referrals/{referralId}/documents/upload`,
  getReferralDocuments: `${api}/connect/referrals/{referralId}/documents`,
  deleteReferralDocument: `${api}/connect/referrals/{referralId}/documents/{documentId}`,
  systemConfiguration: `${api}/connect/accounts/{accountId}/configurationOptionValues/SystemConfiguration`,
  uploadMatterInfoFile: `${api}/connect/matters/{matterId}/documents/upload`,
  sendMessageFromUnityConnect: `${api}/connect/matters/{matterId}/sendMessage`,
  getdocSharingMessages: `${api}/connect/matters/{matterId}/docSharingMessages`,
  getdocSharingMessage: `${api}/connect/matters/{matterId}/docSharingMessages/{docSharingMessageId}`,
  getCirfConfig: `${api}/connect/matters/{matterId}/cirfConfig`,
  updateNotificationPreference: `${api}/connect/users/currentUser/myProfile/notificationPreference/{notificationPreferenceType}`,
  updateLoginParams: `${api}/connect/authorize/updateLoginParams`,
  loginId: `${api}/connect/users/currentUser/loginId`,
  lookUpCirf: `${api}/connect/cirfs/lookupByClient`,
  copyCirfClientDocuments: `${api}/connect/cirfs/{cirfGuid}/client/{clientId}/fromCirf/{fromCirfGuid}/fromClient/{fromClientId}/copy`,
  updateSharedDocumentsPackageHistory: `${api}/unity/sharedDocumentsPackages/{packageGuid}/history/{historyId}`,
};
